







































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { VForm, User } from '@/@types';
import { notEmptyRules } from '@/@utils';

@Component
export default class DialogUser extends Vue {
  /* ------------------------------------
  => Props declaration
  ------------------------------------ */
  @Prop({ required: true, type: Boolean })
  readonly dialog!: boolean;

  @Prop({ required: true, type: String })
  readonly type!: string;

  @Prop({ required: true, type: Object })
  readonly user!: User;

  @Prop({
    required: false,
    type: Function,
    default() {
      return true;
    }
  })
  readonly closeDialog!: FunctionConstructor;

  /* ------------------------------------
  => Local State Declaration
  ------------------------------------ */
  displayName: string = '';
  valid: boolean = true;

  /* ------------------------------------
  => Setter and Getter
  ** (Adopt store variables to local state)
  ------------------------------------ */
  get isLoading(): boolean {
    return this.$store.state.user.isLoading;
  }

  /* ------------------------------------
  => Methods
  ------------------------------------ */
  editUser(): void {
    const editUserForm = this.$refs.editUserForm as VForm;
    if (editUserForm.validate()) {
      const data: User = {
        ...this.user
      };
      data.displayName = this.displayName;
      this.$store.dispatch('user/editUser', data).then(() => {
        this.closeDialog();
      });
    }
  }

  deleteUser(): void {
    this.$store.dispatch('user/deleteUser', this.user).then(() => {
      this.closeDialog();
    });
  }

  notEmpty(identifier: string): any[] {
    return notEmptyRules(identifier);
  }

  /* ------------------------------------
  => Watcher
  ------------------------------------ */
  @Watch('dialog')
  async handleOnLoad(newValue: boolean): Promise<void> {
    if (newValue && this.type === 'edit') {
      this.displayName = this.user.displayName;
    }
  }
}
